import { render, staticRenderFns } from "./navMenu.vue?vue&type=template&id=fb40133c&scoped=true&"
import script from "./navMenu.vue?vue&type=script&lang=js&"
export * from "./navMenu.vue?vue&type=script&lang=js&"
import style0 from "./navMenu.vue?vue&type=style&index=0&id=fb40133c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb40133c",
  null
  
)

export default component.exports